import { STM } from '../context/types'
import { ar_ma } from './ar-ma'
import { ar_sa } from './ar-sa'
import { be_nl } from './be-nl'
import { de_de } from './de-de'
import { en_en } from './en-en'
import { es_es } from './es-es'
import { fr_fr } from './fr-fr'
import { hu_hu } from './hu-hu'
import { it_it } from './it-it'
import { nl_nl } from './nl-nl'
import { pl_pl } from './pl-pl'
import { pt_pt } from './pt-pt'
import { ro_ro } from './ro-ro'
import { tr_tr } from './tr-tr'
import { TKeys } from './types'
import { ar_maStatements, extra360Ar_MaStatements } from './values_survey_AR_MA'
import { ar_saStatements, extra360Ar_SaStatements } from './values_survey_AR_SA'
import { be_nlStatements, extra360Be_NlStatements } from './values_survey_BE_NL'
import { de_deStatements, extra360De_DeStatements } from './values_survey_DE_DE'
import { en_enStatements, extra360En_EnStatements } from './values_survey_EN_EN'
import { es_esStatements, extra360Es_EsStatements } from './values_survey_ES_ES'
import { extra360Fr_FrStatements, fr_frStatements } from './values_survey_FR_FR'
import { hu_huStatements, extra360Hu_HuStatements } from './values_survey_HU_HU'
import { it_itStatements, extra360It_ItStatements } from './values_survey_IT_IT'
import { nl_nlStatements, extra360Nl_NlStatements } from './values_survey_NL_NL'
import { pl_plStatements, extra360Pl_PlStatements } from './values_survey_PL_PL'
import { pt_ptStatements, extra360Pt_PtStatements } from './values_survey_PT_PT'
import { ro_roStatements, extra360Ro_RoStatements } from './values_survey_RO_RO'
import { tr_trStatements, extra360Tr_TrStatements } from './values_survey_TR_TR'

// BCP-47 lower-cased language codes for all supported languages
export const ALL_LANGUAGES = [
    'fr-fr',
    'fr-be',
    'fr-ca',
    'en-us',
    'en-gb',
    'en-be',
    'nl-nl',
    'nl-be',
    'de-de',
    'es-es',
    'it-it',
    'pl-pl',
    'pt-pt',
    'pt-br',
    'tr-tr',
    'ro-ro',
    'hu-hu',
    'ar',
    'ar-ma',
    'ar-sa',
    'ar-ae',
    'ar-eg',
    'ar-dz',
    'ar-iq',
    'ar-jo',
    'ar-lb',
    'ar-ly',
    'ar-om',
    'ar-qa',
] as const
export type ALL_LANGUAGES_TYPE = (typeof ALL_LANGUAGES)[number]

export const AR_DEFAULT: ALL_LANGUAGES_TYPE = 'ar-ma'



export type LnRecord = {
    key: ALL_LANGUAGES_TYPE
    label: string
    Flag: string
    i18n: Record<TKeys, string>
    statements: STM[]
    extra360: Omit<STM, 'title'>[]
}

export const LOCAL_MAP: Record<ALL_LANGUAGES_TYPE, LnRecord> = {
    'fr-fr': {
        key: 'fr-fr',
        label: 'Français',
        Flag: '🇫🇷',
        i18n: fr_fr,
        statements: fr_frStatements,
        extra360: extra360Fr_FrStatements,
    },
    'fr-be': {
        key: 'fr-be',
        label: 'Français (BE)',
        Flag: '🇧🇪',
        i18n: fr_fr,
        statements: fr_frStatements,
        extra360: extra360Fr_FrStatements,
    },
    'fr-ca': {
        key: 'fr-ca',
        label: 'Français (QC)',
        Flag: '🇨🇦',
        i18n: fr_fr,
        statements: fr_frStatements,
        extra360: extra360Fr_FrStatements,
    },
    'en-us': {
        key: 'en-us',
        label: 'English (US)',
        Flag: '🇺🇸',
        i18n: en_en,
        statements: en_enStatements,
        extra360: extra360En_EnStatements,
    },
    'en-gb': {
        key: 'en-gb',
        label: 'English (UK)',
        Flag: '🇬🇧',
        i18n: en_en,
        statements: en_enStatements,
        extra360: extra360En_EnStatements,
    },
    'en-be': {
        key: 'en-be',
        label: 'English (BE)',
        Flag: '🇧🇪',
        i18n: en_en,
        statements: en_enStatements,
        extra360: extra360En_EnStatements,
    },
    'nl-nl': {
        key: 'nl-nl',
        label: 'Nederlands (NL)',
        Flag: '🇳🇱',
        i18n: nl_nl,
        statements: nl_nlStatements,
        extra360: extra360Nl_NlStatements,
    },
    'nl-be': {
        key: 'nl-be',
        label: 'Nederlands (BE)',
        Flag: '🇧🇪',
        i18n: be_nl,
        statements: be_nlStatements,
        extra360: extra360Be_NlStatements,
    },
    'de-de': {
        key: 'de-de',
        label: 'Deutsch',
        Flag: '🇩🇪',
        i18n: de_de,
        statements: de_deStatements,
        extra360: extra360De_DeStatements,
    },
    'es-es': {
        key: 'es-es',
        label: 'Español',
        Flag: '🇪🇸',
        i18n: es_es,
        statements: es_esStatements,
        extra360: extra360Es_EsStatements,
    },
    'it-it': {
        key: 'it-it',
        label: 'Italiano',
        Flag: '🇮🇹',
        i18n: it_it,
        statements: it_itStatements,
        extra360: extra360It_ItStatements,
    },
    'pl-pl': {
        key: 'pl-pl',
        label: 'Polski',
        Flag: '🇵🇱',
        i18n: pl_pl,
        statements: pl_plStatements,
        extra360: extra360Pl_PlStatements,
    },
    'pt-pt': {
        key: 'pt-pt',
        label: 'Português',
        Flag: '🇵🇹',
        i18n: pt_pt,
        statements: pt_ptStatements,
        extra360: extra360Pt_PtStatements,
    },
    'pt-br': {
        key: 'pt-br',
        label: 'Português (BR)',
        Flag: '🇧🇷',
        i18n: pt_pt,
        statements: pt_ptStatements,
        extra360: extra360Pt_PtStatements,
    },
    'tr-tr': {
        key: 'tr-tr',
        label: 'Türk',
        Flag: '🇹🇷',
        i18n: tr_tr,
        statements: tr_trStatements,
        extra360: extra360Tr_TrStatements,
    },
    'ro-ro': {
        key: 'ro-ro',
        label: 'Română',
        Flag: '🇷🇴',
        i18n: ro_ro,
        statements: ro_roStatements,
        extra360: extra360Ro_RoStatements,
    },
    'hu-hu': {
        key: 'hu-hu',
        label: 'Magyar',
        Flag: '🇭🇺',
        i18n: hu_hu,
        statements: hu_huStatements,
        extra360: extra360Hu_HuStatements,
    },
    'ar': {
        key: 'ar',
        label: 'العربية الفصحى',
        Flag: '🇸🇦',
        i18n: ar_ma,
        statements: ar_maStatements,
        extra360: extra360Ar_MaStatements,
    },
    'ar-ma': {
        key: 'ar-ma',
        label: 'العربية (المغرب)',
        Flag: '🇲🇦',
        i18n: ar_ma,
        statements: ar_maStatements,
        extra360: extra360Ar_MaStatements,
    },
    'ar-sa': {
        key: 'ar-sa',
        label: 'العربية (السعودية)',
        Flag: '🇸🇦',
        i18n: ar_sa,
        statements: ar_saStatements,
        extra360: extra360Ar_SaStatements,
    },
    'ar-ae': {
        key: 'ar-ae',
        label: 'العربية (الإمارات)',
        Flag: '🇦🇪',
        i18n: ar_ma,
        statements: ar_maStatements,
        extra360: extra360Ar_MaStatements,
    },
    'ar-eg': {
        key: 'ar-eg',
        label: 'العربية (مصر)',
        Flag: '🇪🇬',
        i18n: ar_ma,
        statements: ar_maStatements,
        extra360: extra360Ar_MaStatements,
    },
    'ar-dz': {
        key: 'ar-dz',
        label: 'العربية (الجزائر)',
        Flag: '🇩🇿',
        i18n: ar_ma,
        statements: ar_maStatements,
        extra360: extra360Ar_MaStatements,
    },
    'ar-iq': {
        key: 'ar-iq',
        label: 'العربية (العراق)',
        Flag: '🇮🇶',
        i18n: ar_ma,
        statements: ar_maStatements,
        extra360: extra360Ar_MaStatements,
    },
    'ar-jo': {
        key: 'ar-jo',
        label: 'العربية (الأردن)',
        Flag: '🇯🇴',
        i18n: ar_ma,
        statements: ar_maStatements,
        extra360: extra360Ar_MaStatements,
    },
    'ar-lb': {
        key: 'ar-lb',
        label: 'العربية (لبنان)',
        Flag: '🇱🇧',
        i18n: ar_ma,
        statements: ar_maStatements,
        extra360: extra360Ar_MaStatements,
    },
    'ar-ly': {
        key: 'ar-ly',
        label: 'العربية (ليبيا)',
        Flag: '🇱🇾',
        i18n: ar_ma,
        statements: ar_maStatements,
        extra360: extra360Ar_MaStatements,
    },
    'ar-om': {
        key: 'ar-om',
        label: 'العربية (عُمان)',
        Flag: '🇴🇲',
        i18n: ar_ma,
        statements: ar_maStatements,
        extra360: extra360Ar_MaStatements,
    },
    'ar-qa': {
        key: 'ar-qa',
        label: 'العربية (قطر)',
        Flag: '🇶🇦',
        i18n: ar_ma,
        statements: ar_maStatements,
        extra360: extra360Ar_MaStatements,
    },
} as const

export const DEFAULT_LOCAL: ALL_LANGUAGES_TYPE = 'en-us'
